import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { UserloginComponent } from './components/userlogin/userlogin.component';
import { AppLayoutComponent } from './layout/app-layout/app-layout.component';
import { UserregisterComponent } from './components/userregister/userregister.component';
import { MyTaskComponent } from './components/my-task/my-task.component';
import { ProfileComponent } from './components/profile/profile.component';
import { OrdersComponent } from './components/orders/orders.component';
// import { FooterComponent } from './components/shared/footer/footer.component';
// import { BgSliderComponent } from './components/shared/bg-slider/bg-slider.component';
import { SharedModule } from './components/shared/shared.module';
import { AuthLayoutComponent } from './layout/auth-layout/auth-layout.component';
import { ForgotComponent } from './components/forgot/forgot.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { SignupComponent } from './components/signup/signup.component';
import { OtpComponent } from './components/otp/otp.component';
import { NewpassComponent } from './components/newpass/newpass.component';
import { SliderComponent } from './components/slider/slider.component';
import { TopbarComponent } from './components/topbar/topbar.component';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ActionComponent } from './components/action/action.component';
import { TaskcostComponent } from './components/taskcost/taskcost.component';
import { PaymentComponent } from './components/payment/payment.component';
import { CartComponent } from './components/cart/cart.component';
import { NotificationComponent } from './components/notification/notification.component';
import { AddbalanceComponent } from './components/profile/addbalance/addbalance.component';
import { DebitsuccessComponent } from './components/payment/debitsuccess/debitsuccess.component';
import { UploadphotoComponent } from './components/profile/uploadphoto/uploadphoto.component';

import { NgxDropzoneModule } from 'ngx-dropzone';
import { NgImageSliderModule } from 'ng-image-slider';
import { CarouselModule } from 'ng-carousel-cdk';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CancelsensorComponent } from './components/cancelsensor/cancelsensor.component';
import { AuthService } from './services/auth.service';
import { ObserversModule } from '@angular/cdk/observers';
import { InnerTaskComponent } from './components/my-task/inner-task/inner-task.component';
import { ResetpasswordComponent } from './components/forgot/resetpassword/resetpassword.component';
import { DeleteComponent } from './components/cart/delete/delete.component';
import { GlobeComponent } from './globe/globe.component';
import { ValidationService } from './services/validation.service';
import { SuccessComponent } from './components/forgot/resetpassword/success/success.component';
import { ConfirmDialog } from './components/taskcost/confirmdialog';

import { SafePipe } from 'src/app/services/safe.service';
import { PaypalsuccessComponent } from './components/paypalsuccess/paypalsuccess.component';
import { ErrorComponent } from './components/error/error.component';
import { PaymentsuccessComponent } from './components/paypalsuccess/paymentsuccess/paymentsuccess.component';
import { NoCartComponent } from './components/cart/no-cart/no-cart.component';
import { RequestDemoComponent } from './components/request-demo/request-demo.component';

import { OpenconfirmwarningComponent } from './components/newtask/openconfirmwarning/openconfirmwarning.component';
import { RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { environment } from 'src/environments/environment';
import { RegistersuccessComponent } from './components/userregister/registersuccess/registersuccess.component';
import { DatePipe } from '@angular/common';
import { CountrycheckComponent } from './components/taskcost/countrycheck/countrycheck.component';
import { CancelinvoiceComponent } from './components/orders/cancelinvoice/cancelinvoice.component';
import { CancelpaylaterComponent } from './components/payment/cancelpaylater/cancelpaylater.component';
import { JwtInterceptor } from './services/JwtInterceptor ';
import { AuthInterceptor } from './services/AuthInterceptor';
import { SatellogicWarningComponent } from './components/taskcost/satellogic-warning/satellogic-warning.component';
import { NgxOtpInputModule } from 'ngx-otp-input';
import { SubscriptionComponent } from './components/subscription/subscription.component';
import { DesktopVersionComponent } from './components/my-task/desktop-version/desktop-version.component';
import { DepositsComponent } from './components/deposits/deposits.component';
import { ToiWarningPopupComponent } from './components/my-task/toi-warning-popup/toi-warning-popup.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { FeasibilityComponent } from './components/my-task/feasibility/feasibility.component';
import { OperatorPopupComponent } from './components/taskcost/operator-popup/operator-popup.component';
import { CloudCoverComponent } from './components/cloud-cover/cloud-cover.component';
import { CatalogsPopupComponent } from './components/my-task/catalogs-popup/catalogs-popup.component';
import { ReturnRefundComponent } from './components/collections/return-refund/return-refund.component';
import { FundAllocationComponent } from './components/fund-allocation/fund-allocation.component';
import { PaymentNotificationComponent } from './components/payment/payment-notification/payment-notification.component';
import { AllocationNotificationComponent } from './components/fund-allocation/allocation-notification/allocation-notification.component';

import { StarRatingComponent } from './components/my-task/star-rating/star-rating.component';
import { FilterPopupComponent } from './components/collections/filter-popup/filter-popup.component';
import { BudgetsComponent } from './components/budgets/budgets.component';
import { BudgetpopupComponent } from './components/newtask/budgetpopup/budgetpopup.component';
import { WarningPopupComponent } from './components/collections/warning-popup/warning-popup.component';
import { OpportunityComponent } from './components/my-task/opportunity/opportunity.component';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE, DateAdapter } from '@angular/material/core';
import { CreateTaskConfirmDialog } from './components/collections/confirm-dialog/confirmdialog'
import { QuotationPopupComponent } from './components/userregister/quotation-popup/quotation-popup.component';
import { QuotesComponent } from './components/quotes/quotes.component';
import { DecimalPipe } from '@angular/common';
import { CustomTooltipDirective } from './components/my-task/custom-tooltip/custom-tooltip.directive';
// import { MatTooltipModule } from '@angular/material/tooltip';
import { LeafletFeasibilityPreviewComponent } from './components/my-task/feasibility/leaflet-feasibility-preview/leaflet-feasibility-preview.component';
import { LeafletTaskComponent } from './components/leaflet-task/leaflet-task.component';
import { LeafletNewcollectionsComponent } from './components/leaflet-newcollections/leaflet-newcollections.component';
import { LeafletNewpreviewComponent } from './components/leaflet-newpreview/leaflet-newpreview.component';
// import { WhatsNewComponent } from './components/shared/footer/whats-new/whats-new.component';
// import { RequiredPopupComponent } from './components/taskcost/required-popup/required-popup.component';
// import { UserManagementComponent } from './components/user-management/user-management.component';
// import { TaskcostSensorPreviewComponent } from './components/newtask/taskcost-sensor-preview/taskcost-sensor-preview.component';
// import { HistoryActionsComponent } from './components/history-actions/history-actions.component';
// import { EulaIntroductionComponent } from './components/payment/eula-introduction/eula-introduction.component';

import { RequiredPopupComponent } from './components/taskcost/required-popup/required-popup.component';

import { TaskAgreementDialogComponent } from './components/collections/task-agreement-dialog/task-agreement-dialog.component';
import { PreviewGeojsonLeafletMapComponent } from './components/taskcost/preview-geojson-leaflet-map/preview-geojson-leaflet-map';
import { PreviewGeojsonComponent } from './components/taskcost/previewgeojson/previewgeojson.component';
import { AnnouncementBannerComponent } from './components/my-task/announcement-banner/announcement-banner.component';
import { WildcardRedirectComponent } from './components/shared/utils/wildcard-redirect-componenet';
import { LeafletUserPreviescreenComponent } from './components/leaflet-user-previescreen/leaflet-user-previescreen.component';
import { ChatBotComponent } from './components/chat-bot/chat-bot.component';
// import { DragDropModule } from '@angular/cdk/drag-drop';
// import { MatBadgeModule } from '@angular/material/badge';
import { APP_DATE_FORMATS, CustomDateAdapter } from './components/shared';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ClipboardModule} from '@angular/cdk/clipboard';
import { BandSelectorComponent } from './components/shared/band-selector/band-selector.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatChipsModule } from '@angular/material/chips';

@NgModule({
  declarations: [
    AppComponent,
    AuthLayoutComponent,
    AppLayoutComponent,
    UserloginComponent,
    UserregisterComponent,
    MyTaskComponent,
    ProfileComponent,
    OrdersComponent,
    // FooterComponent,
    // BgSliderComponent,
    ForgotComponent,
    SidebarComponent,
    SignupComponent,
    OtpComponent,
    NewpassComponent,
    SliderComponent,
    TopbarComponent,
    PreviewGeojsonComponent,
    ActionComponent,
    TaskcostComponent,
    PaymentComponent,
    CartComponent,
    NotificationComponent,
    AddbalanceComponent,
    DebitsuccessComponent,
    UploadphotoComponent,
    CancelsensorComponent,
    InnerTaskComponent,
    ResetpasswordComponent,
    DeleteComponent,
    GlobeComponent,
    SuccessComponent,
    ConfirmDialog,
    SafePipe,
    PaypalsuccessComponent,
    ErrorComponent,
    PaymentsuccessComponent,
    NoCartComponent,
    RequestDemoComponent,
    OpenconfirmwarningComponent,
    RegistersuccessComponent,
    CountrycheckComponent,
    CancelinvoiceComponent,
    CancelpaylaterComponent,
    SatellogicWarningComponent,
    DesktopVersionComponent,
    DepositsComponent,
    ToiWarningPopupComponent,
    NotFoundComponent,
    FeasibilityComponent,
    OperatorPopupComponent,
    CloudCoverComponent,
    CatalogsPopupComponent,
    SubscriptionComponent,
    ReturnRefundComponent,
    FundAllocationComponent,
    PaymentNotificationComponent,
    AllocationNotificationComponent,
    StarRatingComponent,
    FilterPopupComponent,
    WarningPopupComponent,
    OpportunityComponent,
    BudgetsComponent,
    BudgetpopupComponent,
    CreateTaskConfirmDialog,
    QuotationPopupComponent,
    QuotesComponent,
    CustomTooltipDirective,
    LeafletTaskComponent,
    LeafletNewcollectionsComponent,
    LeafletNewpreviewComponent,
    LeafletFeasibilityPreviewComponent,
    // WhatsNewComponent,
    RequiredPopupComponent,
    // UserManagementComponent,
    // TaskcostSensorPreviewComponent,
    // HistoryActionsComponent,
    // EulaIntroductionComponent,
    // RequiredPopupComponent,
    TaskAgreementDialogComponent,
    AnnouncementBannerComponent,
    WildcardRedirectComponent,
    PreviewGeojsonLeafletMapComponent,
    LeafletUserPreviescreenComponent,
    ChatBotComponent,
    BandSelectorComponent
  ],

  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
      BrowserModule,
      SharedModule,
      HttpClientModule,
      BrowserAnimationsModule,
      AppRoutingModule,
      NgxDropzoneModule,
      NgImageSliderModule,
      CarouselModule,
      ObserversModule,
      RecaptchaV3Module,
      NgxOtpInputModule,
      DragDropModule,
      ClipboardModule,
      ScrollingModule,
      MatChipsModule,
    ],

  providers: [
    { provide: AuthService,},
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recaptcha.siteKey,
    },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: DateAdapter, useClass: CustomDateAdapter },
    ValidationService, DatePipe, DecimalPipe
  ],
  bootstrap: [AppComponent],
})
export class AppModule {

}
